// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"f7b07037","384":"ca3f7e5c","582":"44355fad","938":"5cfcf10a"}[chunkId] + ".chunk.css";
};